import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { OptionDescription } from 'owa-options-controls';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { getPremiumUser } from 'owa-domain-option/lib/actions/getPremiumUser';
import { setSafeLinksSettingAction } from '../actions/setSafeLinksSetting';
import store from 'owa-domain-option/lib/store/store';
import { isFeatureEnabled } from 'owa-feature-flags';

const styles = require('./AdvancedSecurityOptionFull.scss');

@observer
export default class AdvancedSecurityOptionFull extends React.Component<{}, {}> {
    componentDidMount() {
        getPremiumUser();
    }

    render() {
        return (
            <div>
                <div>
                    <OptionDescription>
                        {strings.options_premium_AdvancedSecurityContent_part1}
                    </OptionDescription>
                    <div>
                        <Link href="https://aka.ms/outlookcomadvancedsecurityfaq" target="_blank">
                            {strings.options_premium_AdvancedSecurityContent_LearnMore}
                        </Link>
                    </div>
                </div>

                {isFeatureEnabled('auth-safelinksOptionControl') && (
                    <div className={styles.safeLinksContainer}>
                        <div className={styles.safeLinks_description}>
                            <OptionDescription>
                                {strings.options_premium_AdvancedSecurity_Safelinks_description}
                            </OptionDescription>
                        </div>
                        <div className={styles.safeLinks_toggleBtn_Container}>
                            <Toggle
                                checked={store.userInfo.safeLinksEnabled}
                                onChanged={setSafeLinksSettingAction}
                                onText={strings.options_premium_AdvancedSecurity_Safelinks_toggleOn}
                                offText={
                                    strings.options_premium_AdvancedSecurity_Safelinks_toggleOff
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
